import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const CLASSNAMES = {
  container:
    "hover:bg-primary overflow-hidden max-w-[250px] min-w-[250px] sm:max-w-[300px] sm:min-w-[300px] xl:max-w-[500px] xl:min-w-[500px] flex-1 cursor-pointer hover:shadow-md hover:shadow-primary rounded shadow-lg shadow-secondary aspect-square inline-grid justify-center items-center m-4 bg-secondary text-center text-xl text-white box-border",
  label:
    "cursor-pointer text-ellipsis text-2xl sm:text-3xl xl:text-5xl font-bold text-white",
  button:
    "hover:border hover:border-secondary hover:shadow-sm hover:shadow-black shadow-md shadow-black border border-primary flex flex-row bg-white text-secondary justify-center rounded-lg px-2 py-1 text-center whitespace-nowrap w-[150px] m-auto",
};

const Card = ({ classNames = CLASSNAMES, link = "/", label = "" }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(link);
  };
  return (
    <div
      className={classNames?.container || CLASSNAMES.container}
      onClick={handleClick}
    >
      <label className={classNames?.label || CLASSNAMES.label}>{label}</label>
      <Link href={link} className={classNames?.button || CLASSNAMES.button}>
        See Pricing
      </Link>
    </div>
  );
};

export default Card;
